<template>
    <router-link 
        :to="{ name: 'journey-overview' }"
         v-slot="{ href }"
    >
        <a class="btn btn-outline-secondary" :href="href">
            <i class="fas fa-route"></i> {{resource('JourneyBuilder_To_Overview_Button_Text')}}
        </a>
    </router-link>
</template>

<script>
import resourceMixin from "@core/Util/Mixins/resources";

export default {
    name: "NavigateToOverviewButton",
    mixins: [resourceMixin]
}
</script>
